module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book.1caf121b.woff";